/**
 * DevExtreme (esm/ui/grid_core/ui.grid_core.editing_constants.js)
 * Version: 22.1.4
 * Build date: Fri Jul 22 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export var EDITOR_CELL_CLASS = "dx-editor-cell";
export var ROW_CLASS = "dx-row";
export var CELL_MODIFIED_CLASS = "dx-cell-modified";
export var ROW_SELECTED_CLASS = "dx-selection";
export var EDIT_FORM_CLASS = "edit-form";
export var DATA_EDIT_DATA_INSERT_TYPE = "insert";
export var DATA_EDIT_DATA_REMOVE_TYPE = "remove";
export var EDITING_POPUP_OPTION_NAME = "editing.popup";
export var EDITING_FORM_OPTION_NAME = "editing.form";
export var EDITING_EDITROWKEY_OPTION_NAME = "editing.editRowKey";
export var EDITING_EDITCOLUMNNAME_OPTION_NAME = "editing.editColumnName";
export var TARGET_COMPONENT_NAME = "targetComponent";
export var EDITORS_INPUT_SELECTOR = "input:not([type='hidden'])";
export var FOCUSABLE_ELEMENT_SELECTOR = "[tabindex], " + EDITORS_INPUT_SELECTOR;
export var EDIT_MODE_BATCH = "batch";
export var EDIT_MODE_ROW = "row";
export var EDIT_MODE_CELL = "cell";
export var EDIT_MODE_FORM = "form";
export var EDIT_MODE_POPUP = "popup";
export var FIRST_NEW_ROW_POSITION = "first";
export var LAST_NEW_ROW_POSITION = "last";
export var PAGE_BOTTOM_NEW_ROW_POSITION = "pageBottom";
export var PAGE_TOP_NEW_ROW_POSITION = "pageTop";
export var VIEWPORT_BOTTOM_NEW_ROW_POSITION = "viewportBottom";
export var VIEWPORT_TOP_NEW_ROW_POSITION = "viewportTop";
export var EDIT_MODES = [EDIT_MODE_BATCH, EDIT_MODE_ROW, EDIT_MODE_CELL, EDIT_MODE_FORM, EDIT_MODE_POPUP];
export var ROW_BASED_MODES = [EDIT_MODE_ROW, EDIT_MODE_FORM, EDIT_MODE_POPUP];
export var MODES_WITH_DELAYED_FOCUS = [EDIT_MODE_ROW, EDIT_MODE_FORM];
